module.exports = __webpack_public_path__ + "img/header-diamondJewelryCollectionRings@2x.d481567.jpg";